module.exports = __webpack_public_path__ + "img/21-unnc-alpha.fb800c73.png";